import { axiosPrivateInstance } from 'libs/axios';
import { UPDATE_AUDIT_TRAIL_APPROVE_STATUS } from 'utils/serviceUrls';

const approveAuditTrailService = async (id: string, message: string) => {
	const paramData = {
		encReportId: id,
		comment: message,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(UPDATE_AUDIT_TRAIL_APPROVE_STATUS, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default approveAuditTrailService;
